import { requestLessonActions } from "@/services/ai/client";
import { putObject } from "@/services/storage/client";

/**
 * Homework Engine — generates a practice set FROM this session's
 * mistakes (never generic) by asking the AI Engine for a short lesson
 * scoped to exactly those concepts, then persists it to R2 for the
 * Homework page to read.
 */
export class HomeworkEngine {
  async generateFromMistakes(studentId: string, sessionId: string, mistakes: string[]) {
    if (mistakes.length === 0) return null;

    const topic = `Targeted practice: ${mistakes.join(", ")}`;
    const actions = await requestLessonActions(topic, mistakes);

    const homework = { studentId, sessionId, sourceMistakes: mistakes, actions };
    await putObject(`homework/${sessionId}.json`, homework);
    return homework;
  }
}
